<ng-container *rxLet="vm$; let vm;">
  <app-form-select
    [formControl]="formControl"
    label="Servicer Type"
    [data]="vm.servicerTypes"
    [loading]="vm.loading"
    (itemSelected)="servicerTypeChanged.emit($event)"></app-form-select>
</ng-container>
